import axios from "../utils/axios";

export const getAllEmployees = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/employees', { params });
    return data;
};

export const getEmployeesForSelect = async (filters = {}) => {
    const params = {};
    if (filters.school_id) params.school_id = filters.school_id;
    if (filters.department_id) params.department_id = filters.department_id;
    if (filters.job_title_id) params.job_title_id = filters.job_title_id;
    if (filters.exclude_assigned_item_id) params.exclude_assigned_item_id = filters.exclude_assigned_item_id;
    if (filters.exclude_assigned_school_id) params.exclude_assigned_school_id = filters.exclude_assigned_school_id;
    if (filters.exclude_assigned_year_id) params.exclude_assigned_year_id = filters.exclude_assigned_year_id;
    const { data } = await axios.get('/employees/for-select', { params });
    return data;
};

export const getEmployee = async (id) => {
    const { data } = await axios.get(`/employees/${id}`);
    return data;
};

export const createEmployee = async (req) => {
    const { data } = await axios.post('/employees', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const updateEmployee = async (req, id) => {
    const { data } = await axios.put(`/employees/${id}`, req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteEmployee = async (id) => {
    const { data } = await axios.delete(`/employees/${id}`, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteAllEmployees = async (req) => {
    const { data } = await axios.delete('/employees/mass-destroy', { data: req, headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteEmployee = async (id) => {
    const { data } = await axios.delete(`/employees/${id}/force-delete`, { headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteAllEmployees = async (ids) => {
    const { data } = await axios.delete('/employees/mass-force-delete', { data: ids, headers: { Accept: 'application/json' } });
    return data;
};

export const restoreEmployee = async (id) => {
    const { data } = await axios.post(`/employees/${id}/restore`, {}, { headers: { Accept: 'application/json' } });
    return data;
};

export const restoreAllEmployees = async (req) => {
    const { data } = await axios.post('/employees/mass-restore', req, { headers: { Accept: 'application/json' } });
    return data;
};
